export const AUTH = {
    EXPIRE_ACCESS_TOKEN: 30,
    EXPIRE_REFRESH_TOKEN: 30,
    EXPIRE_USER_ROLE: 7,
    USED: 'USED',
    INVALID: 'INVALID',
};



